module.exports = __webpack_public_path__ + "static/img/31.712124c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITO/31.png
// module id = QLmy
// module chunks = 1